import moment from 'moment'
import React from 'react'

const PurchaseTableRow = ({ purchase }) => {

  return (
    <div className="row align-items-center py-3">
      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Date :</h5>
          <p id="donation-date">
            {moment(purchase.donation_date).format("DD/MM/YYYY")}
          </p>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="form-field">
          <h5 className="form-title">Purpose :</h5>
          <p id="donation-date">{purchase?.scheme_type?.name}</p>
        </div>
      </div>
      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Status :</h5>
          <p
            id="donation-status"
            className={`text-uppercase success`}
          >
            Success
          </p>
        </div>
      </div>
      <div className="col-lg-3">
        <div className="form-field">
          <h5 className="form-title">Name :</h5>
          <p id="donation-name">{purchase?.donor_name}</p>
        </div>
      </div>
      <div className="col-lg-2">
        <div className="form-field">
          <h5 className="form-title">Amount :</h5>
          <p id="donation-amount">{purchase?.amount}</p>
        </div>
      </div>
    </div>
  )
}

export default PurchaseTableRow